const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 接口文档地址：
// http://192.168.0.19:8765/swagger-ui.html#/base-data-controller/cityListUsingPOST
const consumer_hotel_common_cityList = (pParameter) => {
    if (!pParameter) pParameter = {};
    const countryType = pParameter.countryType || 1;

    const p = {
        method: 'post',
        urlSuffix: '/consumer/hotel/common/cityList',
        data: {
            countryType,
        },
        check_token: false,
    };
    return Q.when()
        .then(function () {
            return __request(p);
        })
        .then(function (data) {
            return Q.resolve(data);
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};
module.exports = consumer_hotel_common_cityList;
